import { UserType } from '@buck-e-icp/interfaces';

import { AppComponent } from './app.component';
import { loggedInGuard, redirectGuard } from './auth/guards';
import { userTypeGuard } from './core/guards';
import { BuckeRoutes } from './core/interfaces';
import { LoadingComponent } from './shared/components';
import { runGuardsSerially } from './shared/utils';

export default [
    { path: 'auth', loadChildren: () => import('./auth/auth-routes') },
    {
        path: '',
        component: AppComponent,
        canActivate: [runGuardsSerially(loggedInGuard, redirectGuard)],
        children: [
            { path: '', component: LoadingComponent },
            {
                path: 'admin',
                canActivate: [userTypeGuard([UserType.ADMIN])],
                loadChildren: () => import('./dashboards/admin-dashboard/admin-dashboard-routes'),
            },
            {
                path: 'management',
                canActivate: [userTypeGuard([UserType.ADMIN, UserType.SCHOOL, UserType.CITY])],
                loadChildren: () => import('./dashboards/management-dashboard/management-dashboard-routes'),
            },
            {
                path: 'parent',
                canActivate: [userTypeGuard([UserType.PARENT])],
                loadChildren: () => import('./dashboards/parent-dashboard/parent-dashboard-routes'),
            },
        ],
    },
] satisfies BuckeRoutes;
